<template>
	<information-default
		:nameButton="$t('views.ForgotPassSuccess.nameButton')"
		action="login"
		:title="$t('views.ForgotPassSuccess.title')"
	></information-default>
</template>
<script>
import InformationDefault from "../../components/Sections/InformationDefault";
export default {
	components: {
		InformationDefault
	}
};	
</script>
<style lang="scss" scoped></style>
